






































































import { Component, Inject, Vue } from "vue-property-decorator";
import { IProvisioningProvider } from "@/models/providers/contractProduct";
import { ValidationObserver } from "vee-validate";

@Component({
  components: {
    "cprod-prov-actions": () =>
      import("@/components/app/global/contractProducts/cProdProvActions.vue"),
    "cprod-prov-config": () =>
      import("@/components/app/global/contractProducts/cProdProvConfig.vue"),
    "cprod-prov-config-manage-form": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvConfigManageForm.vue"
      ),
    "cprod-prov-requests-table": () =>
      import(
        "@/components/app/global/contractProducts/cProdProvRequestsTable.vue"
      )
  }
})
export default class AdminCProdProvView extends Vue {
  // Refs

  public declare $refs: {
    observer: InstanceType<typeof ValidationObserver>;
    manageConfigurationForm: any;
  };

  // Inject

  @Inject({ from: "cProdProvProvider" })
  public readonly $cProdProvData!: () => IProvisioningProvider;

  // Data

  public isEnabled = false;
  public isProcessing = false;

  // Computed

  public get cProdProvData() {
    return this.$cProdProvData();
  }

  public get canAccessView() {
    const { contractProductFields, cProdProvFunctions } = this.cProdProvData;
    if (!this.cProdProvData.hasProvisioning) return false;
    return contractProductFields.length || cProdProvFunctions.length;
  }

  // Life-cycle methods

  public created() {
    if (!this.canAccessView)
      this.$nextTick(() => {
        this.$router
          .replace({
            name: "adminClientCProdOverview"
          })
          .catch(err => err);
      });
  }

  // Methods

  public async validateBeforeSubmit() {
    this.$refs["manageConfigurationForm"].validateBeforeSubmit();
  }

  public async revertToInitialState() {
    this.$refs["manageConfigurationForm"].revertToInitialState();
  }
}
